/* eslint-disable array-callback-return */
import React, { useEffect } from "react";
import WidgetHeader from "components/WidgetHeader/index";
import Fab from "@material-ui/core/Button";

import { sortableContainer, sortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";

import icon_realtime from "assets/images/icon-realtime.png";
import icon_body from "assets/images/icon-body.png";
import icon_chest from "assets/images/icon-chest.png";
import icon_heart from "assets/images/icon-heart.png";
import icon_sleep from "assets/images/icon-sleep.png";
import icon_beats from "assets/images/icon-beats.png";
import icon_check from "assets/images/icon-check.png";
import icon_move from "assets/images/icon-move.png";
import icon_spo2 from "assets/images/icon-heart.png";
import icon_pulse_rate from "assets/images/icon-beats.png";
import ReactTooltip from "react-tooltip";
import icon_signal_quality from "assets/images/icon-signal-quality.png";
import IntlMessages from "util/IntlMessages";

const kpi_details = {
  SLP_STGS: {
    code: "SLP_STGS",
    name: "Sleep Stages",
    img: <img src={icon_sleep} alt="Sleep Stages" />,
    icon: <img src={icon_check} alt="Sleep Stages" />,
  },
  Y_DIST: {
    code: "Y_DIST",
    name: "Chest Displacement",
    img: <img src={icon_chest} alt="Chest Displacement" />,
    icon: <img src={icon_check} alt="Chest Displacement" />,
  },
  MOV: {
    code: "MOV",
    name: "Body Movement",
    img: <img src={icon_body} alt="Body Movement" />,
    icon: <img src={icon_check} alt="Body Movement" />,
  },
  BR: {
    code: "BR",
    name: "Breathing Rate",
    img: <img src={icon_heart} alt="Breathing Rate" />,
    icon: <img src={icon_check} alt="Breathing Rate" />,
  },
  BRV: {
    code: "BRV",
    name: "BR Variability",
    img: <img src={icon_heart} alt="Breathing Rate Variability" />,
    icon: <img src={icon_check} alt="Breathing Rate Variability" />,
  },
  HR: {
    code: "HR",
    name: "Heart Rate Radar",
    img: <img src={icon_beats} alt="Heart Rate Radar" />,
    icon: <img src={icon_check} alt="Heart Rate Radar" />,
  },
  HRV: {
    code: "HRV",
    name: "HR Variability",
    img: <img src={icon_beats} alt="Heart Rate Variability" />,
    icon: <img src={icon_check} alt="Heart Rate Variability" />,
  },
  SPO2: {
    code: "SPO2",
    name: "SPO2",
    img: <img src={icon_spo2} alt="SPO2" />,
    icon: <img src={icon_check} alt="SPO2" />,
  },
  PR: {
    code: "PR",
    name: "Pulse Rate",
    img: <img src={icon_pulse_rate} alt="Pulse Rate" />,
    icon: <img src={icon_check} alt="Pulse Rate" />,
  },
  I: {
    name: "I",
    img: <img src={icon_realtime} alt="I" />,
    icon: <img src={icon_check} alt="I" />,
  },
  Q: {
    name: "Q",
    img: <img src={icon_realtime} alt="Q" />,
    icon: <img src={icon_check} alt="Q" />,
  },
  IQ: {
    name: "I & Q",
    img: <img src={icon_realtime} alt="I & Q" />,
    icon: <img src={icon_check} alt="I & Q" />,
  },
  SQ: {
    code: "SQ",
    name: "Recording Statistics",
    img: <img src={icon_signal_quality} alt="Signal Quality" />,
    icon: <img src={icon_check} alt="Signal Quality" />,
  },
  RII: {
    code: "RII",
    name: "RII",
    img: <img src={icon_heart} alt="RII" />,
    icon: <img src={icon_check} alt="RII" />,
  },
  //ODI Channel in TV Section
  ODI: {
    code: "ODI",
    name: "ODI",
    img: <img src={icon_realtime} alt="I" />,
    icon: <img src={icon_check} alt="I" />,
  },
  SE: {
    code: "SE",
    name: "Sleep Efficiency",
    img: <img src={icon_sleep} alt="SE" />,
    icon: <img src={icon_check} alt="SE" />,
  },
  AHI: {
    code: "AHI",
    name: "AHI",
    img: <img src={icon_heart} alt="AHI" />,
    icon: <img src={icon_check} alt="AHI" />,
  },
  SA: {
    code: "SA",
    name: "Sleep Awake",
    img: <img src={icon_sleep} alt="Sleep Awake" />,
    icon: <img src={icon_check} alt="Sleep Awake" />,
  },
  TB: {
    code: "TB",
    name: "Time in Bed",
    img: <img src={icon_sleep} alt="Time in Bed" />,
    icon: <img src={icon_check} alt="Time in Bed" />,
  },
  weight: {
    code: "weight",
    name: "Weight",
    img: <img src={icon_sleep} alt="Weight" />,
    icon: <img src={icon_check} alt="Weight" />,
  },
  bp: {
    code: "bp",
    name: "Blood Pressure",
    img: <img src={icon_sleep} alt="Blood Pressure" />,
    icon: <img src={icon_check} alt="Blood Pressure" />,
  },
  blood_sugar: {
    code: "blood_sugar",
    name: "Blood Sugar",
    img: <img src={icon_sleep} alt="Blood Sugar" />,
    icon: <img src={icon_check} alt="Blood Sugar" />,
  },
  body_temp: {
    code: "body_temp",
    name: "Body Temperature",
    img: <img src={icon_sleep} alt="Body Temperature" />,
    icon: <img src={icon_check} alt="Body Temperature" />,
  },
  NC_PSG: {
    code: "NC_PSG",
    name: "Nasal Cannula",
    img: <img src={icon_heart} alt="Nasal Cannula" />,
    icon: <img src={icon_check} alt="Nasal Cannula" />,
  },
  THRX_PSG: {
    code: "THRX_PSG",
    name: "Thorax",
    img: <img src={icon_chest} alt="Thorax" />,
    icon: <img src={icon_check} alt="Thorax" />,
  },
  ABD_PSG: {
    code: "ABD_PSG",
    name: "Abdomen",
    img: <img src={icon_body} alt="Abdomen" />,
    icon: <img src={icon_check} alt="Abdomen" />,
  },
  SPO2_PSG: {
    code: "SPO2_PSG",
    name: "SPO2 PSG",
    img: <img src={icon_spo2} alt="SPO2 PSG" />,
    icon: <img src={icon_check} alt="SPO2 PSG" />,
  },
};

const KpiListComp = React.memo((props) => {
  const {
    night_view,
    nights_available,
    available_kpis,
    sorted_kpis,
    sorted_array_kpis,
    set_sorted_kpis,
    select_kpi,
    selected_kpis,
    fetching_kpi_data,
    set_sorted_array_kpis,
    physician_info,
  } = props;

  useEffect(
    () => {
      if (physician_info.kpi_order_preference && night_view) {
        const kpi_order = JSON.parse(physician_info.kpi_order_preference);
        select_kpi(
          Object.keys(kpi_order).filter(
            (k) => kpi_order[k] && available_kpis.includes(k)
          ),
          true,
          true
        );
      }
    },
    [available_kpis]
  );
  if (
    !nights_available ||
    !available_kpis ||
    (available_kpis && available_kpis.length === 0)
  ) {
    return null;
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    set_sorted_kpis(arrayMove(sorted_kpis, oldIndex, newIndex));

    let sorted_array_kpis_keys = Object.keys(sorted_array_kpis);
    let sorted_array_kpis_values = Object.values(sorted_array_kpis);
    sorted_array_kpis_keys = arrayMove(
      sorted_array_kpis_keys,
      oldIndex,
      newIndex
    );
    sorted_array_kpis_values = arrayMove(
      sorted_array_kpis_values,
      oldIndex,
      newIndex
    );
    let final_sorted_array_kpis = mergeArrToJSON(
      sorted_array_kpis_keys,
      sorted_array_kpis_values
    );

    set_sorted_array_kpis(final_sorted_array_kpis);
  };

  const mergeArrToJSON = (array1, array2) =>
    array1
      .map((item, i) => ({ [item]: array2[i] }))
      .reduce((json, val) => Object.assign({}, json, val));

  const SortableContainer = sortableContainer(({ children }) => (
    <ul className="list-inline list-inline-3" style={{ maxHeight: "400px" }}>
      {children}
    </ul>
  ));

  const SortableItem = sortableElement(({ kpi }) => {
    return (
      <li
        key={kpi}
        kpi_name={kpi_details[kpi].name}
        className="list-inline-item filter-item"
      >
        <Fab
          disabled={fetching_kpi_data}
          variant="contained"
          disableRipple={true}
          disableFocusRipple={true}
          className={`${selected_kpis[kpi] ? "bg-blue text-white" : ""}`}
          classes={{ label: "kpi-label" }}
          onClick={() => select_kpi(kpi, true)}
        >
          <span data-tip data-for={`tooltip-drag-btn-${kpi}`} className="icon">
            <img alt="Drag" src={icon_move} />
          </span>
          <span className="filter-icon">{kpi_details[kpi].img}</span>
          <span className="filter-text beta-hr">
            {night_view === "multiple_night" && kpi === "MOV"
              ? "Restlessness"
              : kpi_details[kpi].name}
            {kpi === "SLP_STGS" ? <span className="beta-block-hr" /> : ""}
            {kpi === "NC_PSG" ? <span className="beta-tag">PSG</span> : ""}
            {kpi === "THRX_PSG" ? <span className="beta-tag">PSG</span> : ""}
            {kpi === "ABD_PSG" ? <span className="beta-tag">PSG</span> : ""}
            {kpi === "SPO2_PSG" ? <span className="beta-tag">PSG</span> : ""}
          </span>
          <span className="check-icon">{kpi_details[kpi].icon}</span>
        </Fab>
        <ReactTooltip
          id={`tooltip-drag-btn-${kpi}`}
          className="graph-tooltip beta-hr"
          place="right"
        >
          <IntlMessages id="kpi.dragMsg" />
        </ReactTooltip>
      </li>
    );
  });

  return (
    <div className="jr-entry-sec mt-3">
      {sorted_kpis &&
        sorted_kpis.length > 0 && (
          <>
            <WidgetHeader title="Available Channels" />
            <SortableContainer distance={10} onSortEnd={onSortEnd}>
              {sorted_kpis.map((kpi, index) => {
                if (!kpi_details[kpi]) {
                  return;
                }

                return (
                  <SortableItem
                    key={`item-${kpi_details[kpi].name}`}
                    index={index}
                    kpi={kpi}
                  />
                );
              })}
            </SortableContainer>
          </>
        )}
    </div>
  );
});

export default KpiListComp;
